import React from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { FormControlProps } from "react-bootstrap/FormControl";
import { BsPrefixRefForwardingComponent } from "react-bootstrap/helpers";
import { UseFormRegister } from "react-hook-form/dist/types/form";
import { ButtonLoading, hasErrors } from "..";
import { FormErrorMessage } from "./FormErrorMessage";

interface Props extends FormControlProps {
	label?: string;
	placeholder?: string;
	name: string;
	help?: string;
	errors: any;
	firstInput?: boolean;
	register: UseFormRegister<any> | null;
	options?: Record<string, any>;
	onButtonClick: () => void;
	buttonLoading?: boolean;
	buttonText: string;
	buttonClassName?: string;
	onBlur?: () => void;
}

export const FormInputWithButton: BsPrefixRefForwardingComponent<"input", Props> = React.forwardRef(
	(props: Props, ref) => {
		const {
			label,
			options,
			placeholder,
			name,
			errors,
			register,
			buttonLoading,
			buttonText,
			buttonClassName,
			onButtonClick,
			help,
			...controlProps
		} = props;
		const hasError = hasErrors(errors, name);
		return (
			<Form.Group controlId={name} className={`form-group ${props.type === "hidden" ? "mb-0" : ""}`}>
				{!props.firstInput && label && <Form.Label>{label}</Form.Label>}
				<InputGroup className={`${hasError && " is-invalid"}`}>
					{register !== null ? (
						<Form.Control
							{...register(name, options ? options : undefined)}
							{...controlProps}
							placeholder={placeholder}
							isInvalid={hasError}
						/>
					) : (
						<Form.Control {...controlProps} placeholder={placeholder} isInvalid={hasErrors(errors, name)} />
					)}
					{/*<Form.Control name={name} {...controlProps} placeholder={placeholder} isInvalid={hasErrors(errors, name)} />*/}
					{help && <Form.Text muted>{help}</Form.Text>}
					{props.firstInput && label && <Form.Label>{label}</Form.Label>}
					<div className="input-group-append">
						{buttonLoading ? (
							<ButtonLoading
								loading={buttonLoading}
								title={buttonText}
								className={buttonClassName}
								onClick={onButtonClick}
								disabled={props.disabled}
							>
								{buttonText}
							</ButtonLoading>
						) : (
							<Button
								title={props.buttonText}
								onClick={onButtonClick}
								className={buttonClassName}
								disabled={props.disabled}
							>
								{buttonText}
							</Button>
						)}
					</div>
				</InputGroup>
				<FormErrorMessage errors={errors} name={name} />
			</Form.Group>
		);
	}
);

FormInputWithButton.displayName = "FormInputWithButton";
